$.fn.stickToContainer = function(container_selector, offset = 0) {
  let self = this
  container = self.closest(container_selector);
  self.css('width', self.width());
  container.css('position', 'relative');
  change_styles()

  $( window ).scroll(function() {
    change_styles()
  });

  $( window ).resize(function() {
    self.css('width', container.width());
    change_styles()
  });

  function change_styles(){
    if ($.mlmi.mobile.isMobile){
      self.css('position', '');
      self.css('bottom', '');
      self.css('top', '');
      return
    }
    container_offset_top = container.offset().top - window.scrollY;
    container_offset_bottom = container.offset().top - window.scrollY + container.outerHeight() - self.outerHeight();

    if(container_offset_bottom <= offset){
      //stick to bottom of container
      self.css('position', 'absolute');
      self.css('bottom', '0');
      self.css('top', 'auto');
    }else if(container_offset_top <= offset){
      //Stick to top of page
      self.css('position', 'fixed');
      self.css('top', offset);
      self.css('bottom', 'auto');
    }else if(container_offset_top > offset){
      //normal behavior
      self.css('position', '');
      self.css('top', '');
      self.css('bottom', '');
    }
  }

  return function() {
    return self
  }()
};
